import React, { Component } from 'react'
import { connect } from 'react-redux'

// import styles
import './priceapprovalmodal.scss'

// import components
import Modal from '../../components/Modal'
import PriceApproval from '../../../pages/PriceApproval'
// import { hasAccess, hasSubscriptionPermission } from '../../../utils/auth'
// import { translation } from '../../../utils/helpers'

class PriceApprovalModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      headerText: '',
      bottomBarProps: null
    }
    this.setHeader = this.setHeader.bind(this)
    this.setBottomBarProps = this.setBottomBarProps.bind(this)
  }

  componentDidMount () {
  }

  componentWillReceiveProps (newProps) {
  }

  setHeader (text) {
    this.setState({headerText: text})
  }

  setBottomBarProps (bottomBarProps) {
    this.setState({ bottomBarProps: bottomBarProps })
  }

  render () {
    // overflowHidden={this.state.overflowHidden}
    return (
      <div className='priceapprove__modal mozilla-heright-fix'>
        <Modal
          {...this.props}
          header={this.state.headerText}
          bottomBarProps={this.state.bottomBarProps}
          hideX
        >
          {this.renderForm()}
        </Modal>
      </div>
    )
  }

  renderForm () {
    return (
      <PriceApproval
        router={this.props.router}
        renderModal
        shopApproval
        RequireCustomerApproval={this.props.RequireCustomerApproval}
        orderId={this.props.orderId}
        modalCloseCB={this.props.closeModal}
        priceInformation={this.props.priceInformation}
        showAE={this.props.showAE}
        setModalHeader={this.setHeader}
        setBottomBarProps={this.setBottomBarProps}
      />
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
})(PriceApprovalModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/PriceApprovalModal/index.js